import styled from 'styled-components';

export const RegisterWrapper = styled.div`
    max-width: 64rem;
    min-width: 53rem;
    @media (max-width: 768px) {
        max-width: 100%;
        min-width: 100%;
    }
`;